import React from "react";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useGetPublicationHeatMapQuery } from "../../../../redux/service/modules/dashboard";
import { useSelector } from "react-redux";

const PublicationHeatMap = ({ appliedFilters }) => {
    const dateRange = useSelector((state) => state.date);

    const checkIfKeyReport = (row) => {
        const highlightedReports = [
            'Key Reports Summary',
            'All Reports Summary',
            'Weighted Score',
            'Bespoke Total',
            'Weighted d Score'
        ];

        let styles = {};
        if (highlightedReports.includes(row.report_type)) {
            styles = {
                color: "#ED1C24",
                fontWeight: "bold",
            }
        }
        return styles;
    }

    return (
        <div className="overflow-auto">
            <PaginatedDataTable
                appliedFilters={appliedFilters}
                queryHook={useGetPublicationHeatMapQuery}
                initialDateRange={dateRange}
                stickyColumnsCount={1}
                isColumnSticky={true}
                customCellColor={(header, row) => checkIfKeyReport(row)}
            />
        </div>
    );
};

export default PublicationHeatMap;
